/**
 * UnsavedChangesDialog — «tienes cambios sin guardar» de las fichas.
 *
 * Antes cada ficha usaba `window.confirm('¿Descartar y pasar?')`, que solo
 * ofrecía dos salidas: perder los cambios o quedarse. Aquí hay TRES, que es lo
 * que hace falta para ir de ficha en ficha sin soltar el teclado:
 *
 *   · Guardar y continuar → guarda y ejecuta la acción pendiente (pasar de
 *     ficha o cerrar). Es la acción primaria.
 *   · Descartar           → ejecuta la acción pendiente sin guardar.
 *   · Cancelar / Esc      → se queda donde está.
 *
 * Se pinta con `common/Dialog` (portal al body, Esc, fondo, bloqueo de scroll).
 */
import React from 'react';
import Dialog from './Dialog';

export default function UnsavedChangesDialog({
  open = false,
  entity = 'este registro',
  saving = false,
  actionLabel = 'continuar',
  onSave,
  onDiscard,
  onCancel,
}) {
  if (!open) return null;

  return (
    <Dialog
      title="Cambios sin guardar"
      icon="⚠️"
      onClose={() => { if (!saving) onCancel?.(); }}
      busy={saving}
      maxWidth={460}
      footer={(
        <>
          <button
            type="button"
            className="list-btn-secondary"
            onClick={onCancel}
            disabled={saving}
          >
            Cancelar
          </button>
          <button
            type="button"
            className="list-btn-danger"
            onClick={onDiscard}
            disabled={saving}
          >
            Descartar
          </button>
          <button
            type="button"
            className="list-btn-primary"
            onClick={onSave}
            disabled={saving}
          >
            {saving ? 'Guardando…' : 'Guardar y continuar'}
          </button>
        </>
      )}
    >
      <p>
        Tienes cambios sin guardar en <strong>{entity}</strong>.
        {' '}Si {actionLabel}, puedes guardarlos primero; si descartas, se
        perderán los cambios de esta ficha.
      </p>
    </Dialog>
  );
}
